import i18next from 'i18next';

export const getDocLabel = (namePath: string, allValues: any, idCardTypes: any[]): string => {
  const pathParts = namePath.split(/[.[\]]+/).filter(Boolean);

  pathParts.pop();

  const parentObject = pathParts.reduce(
    (obj, key) => (obj && obj[key] !== undefined ? obj[key] : undefined),
    allValues,
  );

  const typeId = parentObject?.idCardType;
  const selectedType = idCardTypes.find((t: any) => t.value === typeId);
  const isOther = selectedType?.value?.toLowerCase().includes('other');

  const baseLabel =
    selectedType && !isOther
      ? selectedType.label
      : i18next.t<string>('FIELDS:ID_CARD', 'Documento');

  return `${baseLabel}`;
};
